// Library imports
import { useRef, useState } from "react";

// User Component imports
import { TextInput, Button } from "_core/components/common/UI";
import { normalizeDomain, domainListErrors } from "../utils/opsDomain";

/**
 * 許可ドメインの入力行（削除で入力欄がずれないよう行ごとに id を振る）
 * @returns {{rows, values: string[], reset, update, normalize, remove, add}}
 */
export const useDomainRows = () => {
    const seq = useRef(0);
    const newRow = (value = "") => ({ id: ++seq.current, value });
    const [rows, setRows] = useState(() => [newRow()]);

    const reset = (domains) => setRows((domains.length ? domains : [""]).map((d) => newRow(d)));
    const update = (id, value) => setRows((prev) => prev.map((row) => (row.id === id ? { ...row, value } : row)));
    // 貼り付けた URL などは入力確定時に host[:port] へ整形する（id を変えて入力欄を作り直す）
    const normalize = (id, value) => {
        const normalized = normalizeDomain(value);
        if (normalized === value) return;
        setRows((prev) => prev.map((row) => (row.id === id ? newRow(normalized) : row)));
    };
    const remove = (id) => setRows((prev) => prev.filter((row) => row.id !== id));
    const add = () => setRows((prev) => [...prev, newRow()]);

    return { rows, values: rows.map((row) => row.value), reset, update, normalize, remove, add };
};

/**
 * 許可ドメインの入力欄（1行1ドメイン。追加・削除ボタンは有人引き継ぎ設定と同じ見た目）
 * showListError=false で「1件以上」等のリスト全体のエラーを隠す（未入力のフォームを開いた直後など）
 */
const OpsDomainListField = ({ domainRows, showListError = true }) => {
    const errors = domainListErrors(domainRows.values);
    return (
        <>
            <div className="ops-domain-list">
                {domainRows.rows.map((row, index) => (
                    <div key={row.id} className="ops-domain-item">
                        <div className="ops-domain-row">
                            <TextInput parentClassName={"ops-domain-input" + (errors.rows[index] ? " is-error" : "")}
                                default={row.value} placeholder="www.example.com" autocorrect={false}
                                onchange={(e) => domainRows.update(row.id, e.target.value)} onblur={(e) => domainRows.normalize(row.id, e.target.value)} />
                            {domainRows.rows.length > 1 &&
                                <Button className="ops-domain-remove" onClick={() => domainRows.remove(row.id)}>
                                    <i className="bi bi-x-lg" />
                                </Button>
                            }
                        </div>
                        {errors.rows[index] && <div className="ops-setting-error">{errors.rows[index]}</div>}
                    </div>
                ))}
            </div>
            {showListError && errors.list && <div className="ops-setting-error">{errors.list}</div>}
            <div>
                <Button className="ops-domain-add" onClick={domainRows.add}>
                    <i className="bi bi-plus-lg" />ドメインを追加
                </Button>
            </div>
        </>
    );
};

export default OpsDomainListField;
